// src/Footer.js
import React, { useState } from 'react';
import Logo from '../assets/NewLogo.png';
import { useNavigate } from 'react-router-dom';
import './footer.css';
import PayUButton from './PayNow';

const Footer = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const dynamicLinks = [
    { name: 'Home', href: '/' },
    { name: 'PravasaOne', href: '/membership' },
    { name: 'AboutUs', href: '/aboutUs' },
    { name: 'Blog', href: '/blog' },
    { name: 'PravasaCare', href: '/NGO' }
  ];
  const commanPages = [
    { name: 'Term and Conditions', href: '/termAndCondition' },
    { name: 'Privacy Policy', href: '/privacyPolicies' },
    { name: 'PravasaOne Services', href: '' },
    { name: 'Customer Care services', href: '' },
    { name: 'Refund Policies', href: '/refundPolicy' }
  ];
  const socialLinks = [
    { name: 'Facebook', href: 'https://www.facebook.com/people/Pravasain/61572669596677/', icon: 'https://img.icons8.com/ios-filled/50/facebook--v1.png' },
    { name: 'Twitter', href: 'https://x.com/pravasa_in', icon: 'https://img.icons8.com/ios-filled/50/twitterx.png' },
    { name: 'Instagram', href: 'https://www.instagram.com/pravasa.in/', icon: 'https://img.icons8.com/ios-filled/50/instagram-new--v1.png' },
    { name: 'LinkedIn', href: 'https://www.linkedin.com/company/pravasa-in/', icon: 'https://img.icons8.com/?size=100&id=8808&format=png&color=000000' }
  ];
  const navigate = useNavigate()
  const handleLogoClick = () => {
    navigate('/');
  }
  const handleAddHotel = () => {
    navigate('/addHotel');
  }
  const handleOpenPopup = () => {
    setShowPopup(true);
    setPasscode("");
    setError("");
  };

  const handleVerify = () => {
    if (passcode === "763459") {
      navigate("/addHotel"); // <-- Change to your target route
    } else {
      setError("Incorrect passcode. Try again.");
    }
  };

  return (
    <footer className="bg-gradient-to-r from-blue-300 to-orange-300  text-white   ">
      <div className="container px-4-0 md:p-6  mx-auto ">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="flex flex-col mb-4">
            <div className="flex-1 flex justify-center   md:item-start md:justify-start">
              <img src={Logo} className='logoFooter' ></img>
            </div>
            {/* <img src="/logo.png" alt="Logo" className="h-12 mb-2" /> */}
            <p className=" text-start text-sm">Contact: customerservice@pravasa.in</p>
            <p className="text-start text-sm">Phone: 📞 011-45657410
            </p>
            <p className="text-start text-sm">Mobile: 📞 +91 93556 67780</p>
            <p className="text-start text-sm">Address: 370A, Second Floor, Sant Nagar,<br /> East of Kailash, New Delhi, Delhi 110065</p>
          </div>
          <div className="flex flex-col md:pt-20  text-center mb-4">
            <h5 className="font-bold mb-4">Links</h5>
            <ul>
              {commanPages.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-100 mr-8  font-semibold font-sans no-underline hover:text-gray-500">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col md:pt-20  text-center mb-4">
            <h5 className="font-bold mb-4">Links</h5>
            <ul>
              {dynamicLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-gray-100 mr-8  font-semibold font-sans no-underline hover:text-gray-500">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col md:pt-20 mb-4 text-center">
            <h5 className="font-bold mb-4">Follow Us</h5>
            <div className="flex justify-center md:justify-end space-x-4">
              {socialLinks.map((link) => (
                <a key={link.name} href={link.href} className="text-gray-300 hover:text-white">
                  <img className='w-8 h-8 md:h-16 md:w-16' src={link.icon}></img>

                </a>
              ))}
            </div>
            <div className='py-4'>
              <PayUButton />
            </div>
            {/* <div className='py-4'>
                            <button className='bg-gray-900 text-white px-4 py-2 rounded' onClick={handleOpenPopup}>Add Hotel</button>
                            {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Enter 6-digit Passcode
            </h2>

            <input
              type="password"
              value={passcode}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 6) setPasscode(value);
              }}
              maxLength={6}
              inputMode="numeric"
              className="w-full border p-2 text-gray-700 rounded text-center tracking-widest text-xl"
              placeholder="______"
            />

            {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

            <div className="mt-4 flex justify-between">
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-600 hover:underline"
              >
                Cancel
              </button>
              <button
                onClick={handleVerify}
                className="bg-green-600 text-white px-4 py-2 rounded"
              >
                Verify
              </button>
            </div>
          </div>
        </div>
      )}
                            
                        </div> */}
          </div>
        </div>
        <div className="border-t border-gray-700 mt-4 p-4 text-center text-sm">
          &copy; {new Date().getFullYear()} PRAVASA. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
